<template>
  <ul class="navbar-nav">
    <sidebar-item
      :link="{
        name: 'Dashboard',
        icon: 'dashboard',
        path: '/dashboard',
      }"
      @click.native="closeAll()"
    />

    <sidebar-item
      v-if="permission < 5"
      :link="{ name: 'Campaigns', icon: 'campaign' }"
      v-model="showCreate"
      @click.native="closeAll('showCreate')"
    >
      <sidebar-item
        :link="{ name: 'Regular', path: '/campaigns' }"
        @click.native="$emit('selected')"
      />
      <!-- <sidebar-item
        :link="{ name: 'Automations', path: '/automation' }"
        @click.native="$emit('selected')"
      /> -->
      <sidebar-item
        :link="{ name: 'Autoresponders', path: '/autoresponder' }"
        @click.native="$emit('selected')"
      />
    </sidebar-item>
    <sidebar-item
      v-bind:link="{
        name: 'Automations',
        icon: 'automation',
        path: showAdvanced ? '/advanced-automation' : '/automation',
      }"
      @click.native="closeAll()"
    />
    <sidebar-item
      v-if="permission < 4"
      :link="{ name: 'Audience', icon: 'audience' }"
      v-model="showRecipients"
      @click.native="closeAll('showRecipients')"
    >
      <sidebar-item
        v-if="allowAudience"
        :link="{ name: 'All contacts', path: '/audience/list' }"
        @click.native="$emit('selected')"
      />
      <sidebar-item
        :link="{ name: 'Lists', path: '/recipients' }"
        @click.native="$emit('selected')"
      />
      <sidebar-item
        :link="{
          name: 'Segments',
          path: '/segment' + (allowAudience ? 's' : ''),
        }"
        @click.native="$emit('selected')"
      />
      <sidebar-item
        :link="{ name: 'Webforms', path: '/webform' }"
        @click.native="$emit('selected')"
      />
      <sidebar-item
        :link="{ name: 'Tags', path: '/contact-tag' }"
        @click.native="$emit('selected')"
      />
      <sidebar-item
        :link="{ name: 'Summary', path: '/contact-summary' }"
        @click.native="$emit('selected')"
      />
    </sidebar-item>

    <sidebar-item
      :link="{ name: 'Reports', icon: 'reports' }"
      v-model="showReport"
      @click.native="closeAll('showReport')"
    >
      <sidebar-item
        :link="{ name: 'Regular campaigns', path: '/campaign-report' }"
        @click.native="$emit('selected')"
      />
      <sidebar-item
        :link="{
          name: 'Automations',
          path: '/automation-report',
        }"
        @click.native="$emit('selected')"
      />
      <sidebar-item
        :link="{
          name: 'Autoresponders',
          path: '/autoresponder-report',
        }"
        @click.native="$emit('selected')"
      />
      <sidebar-item
        :link="{
          name: 'Webforms',
          path: '/webform-report',
        }"
        @click.native="$emit('selected')"
      />
    </sidebar-item>

    <sidebar-item
      v-if="this.user && this.user.mcTemplate && permission < 5"
      :link="{ name: 'Template gallery', icon: 'gallery' }"
      v-model="showGallery"
      @click.native="closeAll('showGallery')"
    >
      <sidebar-item
        :link="{ name: 'Template', path: '/gallery' }"
        @click.native="$emit('selected')"
      />
      <sidebar-item
        :link="{
          name: 'MC template',
          path: '/mailercloud-templates',
        }"
        @click.native="$emit('selected')"
      />
    </sidebar-item>
    <sidebar-item
      v-else-if="(!this.user || !this.user.mcTemplate) && permission < 5"
      :link="{
        name: 'Template gallery',
        icon: 'gallery',
        path: '/gallery',
      }"
      @click.native="closeAll()"
    />
    <sidebar-item
      v-bind:link="{
        name: 'Transactional email',
        icon: 'transational',
        path: '/transactional/dashboard',
      }"
      @click.native="closeAll()"
    />
    <li class="text-left">
      <div class="pl-3 py-2">
        <b-link
          class="btn btn-outline-dark mc-btn b-r-10 w-100"
          to="/change-plan"
        >
          <img
            src="@/assets/img/icons/dashboard/upgrade-icon.svg"
            alt="upgrade"
            width="24"
            class="mr-2"
          />
          <span>Upgrade Plan</span>
        </b-link>
      </div>
    </li>
  </ul>
</template>
<script>
export default {
  name: "mob-menu",
  props: {},
  data() {
    return {
      user: JSON.parse(this.$ls.get("login_data")),
      showReport: false,
      showGallery: false,
      showRecipients: false,
      showCreate: false,
      allowAudience: parseInt(this.$ls.get("allowAudience")),
    };
  },
  methods: {
    closeAll(menu = "") {
      if (menu) {
        var val = this[menu];
      } else {
        this.$emit("selected");
      }
      this.showReport = false;
      this.showGallery = false;
      this.showRecipients = false;
      this.showCreate = false;
      if (menu) {
        this[menu] = val;
      }
    },
  },
};
</script>
